<script>
	export let flex;
	export let right;
</script>

<div class="container" class:flex class:right>
    <slot></slot>
</div>

<style lang="scss">
	.flex {
		display: flex;
	}

	.right {
		justify-content: flex-end;
	}
</style>
